import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LANGUAGE_STORAGE_KEY, isLanguage, localizedPath, splitLocalePath } from './core';
import { prepareLanguage, useStoreLanguage } from './index';

export default function LocaleController() {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();
  const firstVisit = useRef(true);
  const language = useStoreLanguage();
  useEffect(() => {
    if (/^\/admin(?:\/|$)/.test(pathname)) return;
    let cancelled = false;
    let wanted = splitLocalePath(pathname).language;
    if (firstVisit.current && pathname === '/') {
      try {
        const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY);
        if (isLanguage(saved)) wanted = saved;
      } catch { /* Explicit language URLs remain available without browser storage. */ }
    }
    const restore = firstVisit.current && pathname === '/' && wanted !== 'es';
    if (!restore) firstVisit.current = false;
    void prepareLanguage(wanted).then(() => {
      if (cancelled) return;
      firstVisit.current = false;
      if (restore) navigate(localizedPath('/', wanted) + search + hash, { replace: true });
    }).catch(() => { /* A resource failure keeps the existing page usable. */ });
    return () => { cancelled = true; };
  }, [pathname, search, hash, navigate]);
  useEffect(() => { if (!/^\/admin(?:\/|$)/.test(pathname)) document.documentElement.lang = language; }, [language, pathname]);
  return null;
}
